import { useCallback, useEffect, useMemo } from 'react';
import { getMinPricesRequestVariables, getPrices } from '../../../../../utils';
import { CURRENCY_KEY } from '../../../../../../cache';
import { useMinPricesInPeriod } from '@shared/lib/results';
export const useDatepickerMinPrices = ({ locations, passengers, legId, isRT, schedule }) => {
    var _a, _b, _c, _d, _e, _f;
    const minPricesInPeriodParams = useMemo(() => {
        return getMinPricesRequestVariables(locations, passengers);
    }, [locations, passengers]);
    const { data, loading, refetch: refetchPrices, getPrices: getMinPrices } = useMinPricesInPeriod({
        fetchPolicy: 'no-cache',
        variables: { parameters: minPricesInPeriodParams },
        skip: !locations.arrival || !locations.departure || ((_a = locations.arrival) === null || _a === void 0 ? void 0 : _a.iata) === ((_b = locations.departure) === null || _b === void 0 ? void 0 : _b.iata)
    });
    const scheduleTo = (_d = (_c = schedule === null || schedule === void 0 ? void 0 : schedule.to) === null || _c === void 0 ? void 0 : _c.FlightsSchedule) === null || _d === void 0 ? void 0 : _d.datesData;
    const scheduleBack = (_f = (_e = schedule === null || schedule === void 0 ? void 0 : schedule.back) === null || _e === void 0 ? void 0 : _e.FlightsSchedule) === null || _f === void 0 ? void 0 : _f.datesData;
    const minPrices = useMemo(() => {
        return {
            pricesTo: getPrices(getMinPrices(0, isRT), scheduleTo),
            pricesBack: getPrices(getMinPrices(1, isRT), scheduleBack)
        };
    }, [isRT, getMinPrices, scheduleTo, scheduleBack]);
    const onChangeLocalStorage = useCallback((e) => {
        if (e.key === CURRENCY_KEY && e.oldValue !== e.newValue) {
            refetchPrices({ parameters: minPricesInPeriodParams });
        }
    }, [minPricesInPeriodParams]);
    useEffect(() => {
        window.addEventListener('storage', onChangeLocalStorage);
        return () => {
            window.removeEventListener('storage', onChangeLocalStorage);
        };
    }, []);
    return {
        data,
        minPrices,
        pricesByLeg: getPrices(getMinPrices(legId, isRT), legId === 0 ? scheduleTo : scheduleBack),
        loading,
        refetchPrices
    };
};
